export const getDomainName = () => {
    return window.location.hostname?.split('.')?.splice(-2)?.join('.');
};
